import React from 'react';
import ResetPasswordWithLinkPage from './ResetPasswordWithLinkPage';

const ResetPasswordPageConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/password/reset',
			element: (
				<React.Suspense fallback={<div>Loading...</div>}>
					<ResetPasswordWithLinkPage />
				</React.Suspense>
			),
		},
	],
};

export default ResetPasswordPageConfig;
